export default __webpack_public_path__ + "static/media/gilroy-medium.bd87f033.svg";